import { Text, TextClassContext } from '@/components/ui/text';
import { View } from 'react-native';

export interface HumanChatMessageBodyProps {
  content: string;
  /** Smaller type for the right-rail chat. */
  compact?: boolean;
}

export const HumanChatMessageBody = ({
  content,
  compact,
}: HumanChatMessageBodyProps) => {
  return (
    <View className="p-3.5 rounded-2xl max-w-[85%] bg-foreground self-end">
      <TextClassContext.Provider
        value={
          compact
            ? 'text-sm text-background text-right'
            : 'text-[15px] leading-[21px] text-background text-right'
        }
      >
        <Text>{content}</Text>
      </TextClassContext.Provider>
    </View>
  );
};
